<template>
  <div class="translationChecks">
    <!-- <div class="miniTitle d-flex justify-content-between" @click="translationCheckBoxesToggle = !translationCheckBoxesToggle">
        <div>Jazyk</div>
        <div class="languageArrow">
            <img v-if="translationCheckBoxesToggle" src="@/assets/images/blueboxArrowOpen.jpg" border="0" alt="">
            <img v-if="!translationCheckBoxesToggle" src="@/assets/images/blueboxArrowClosed.jpg" border="0" alt="">
        </div>
    </div> -->
    <div id="checkBoxDiv">
      <div
        v-for="(item, index) in Object.keys(checkBoxSettings)"
        :key="index"
        :class="[
          // index + 1 == Object.keys(checkBoxSettings).length && 'sep',
          index == 0 && 'default',
        ]"
        class="d-flex align-items-center"
        style="padding-bottom: 2px;"
      >
        <input
          type="checkbox"
          :name="'lang_' + index"
          @click="checkBoxClick(item)"
          :id="'lang_' + index"
          :checked="checkBoxSettings[item] && checkBoxSettings[item].checked"
          class="styled-checkbox"
        />
        <label :for="'lang_' + index" style="user-select: none">
          {{ checkBoxSettings[item].langName }}
        </label>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from "@/apiList";

export default {
  name: "ZoomingFunction",
  data() {
    return {
      checkBoxSettings: this.$store.getters.transCheckBoxSettings,
      translationCheckBoxesToggle: true,

      czechLangId: JSON.parse(localStorage.getItem("czechLangId")),
      arabicLangId: JSON.parse(localStorage.getItem("arabicLangId")),
      languages: JSON.parse(localStorage.getItem("languages")),
    };
  },
  methods: {
    async setCheckBoxes() {
      if (!this.czechLangId || !this.arabicLangId) {
        await this.setArabicAndCzechLangId();
      }
      let settings = {};
      let result = Object.keys(this.languages).map((key) => [
        this.languages[key]._id,
        this.languages[key],
      ]);
      let newArray = [];
      let arabicLangObj, czechLangObj;
      result.forEach((elem) => {
        if (elem[0] === this.arabicLangId)
          arabicLangObj = [elem[0], { langName: elem[1].name, checked: true }];
        else if (elem[0] === this.czechLangId)
          czechLangObj = [elem[0], { langName: elem[1].name, checked: true }];
        else
          newArray.push([elem[0], { langName: elem[1].name, checked: false }]);
      });
      newArray.splice(0, 0, arabicLangObj);
      newArray.splice(1, 0, czechLangObj);
      newArray.forEach((elem) => {
        settings[elem[0]] = elem[1];
      });
      this.checkBoxSettings = settings;
      this.$store.dispatch("transCheckBoxSettings", this.checkBoxSettings);
    },
    async setArabicAndCzechLangId() {
      let languages = JSON.parse(localStorage.getItem("languages"));
      languages.forEach((elem) => {
        if (elem.name == "Arabština" || elem.name == "arabic") {
          this.arabicLangId = elem._id;
          localStorage.setItem("arabicLangId", JSON.stringify(elem._id));
        }
        if (elem.name == "Čeština - Hrbek" || elem.name == "hrbek") {
          this.czechLangId = elem._id;
          localStorage.setItem("czechLangId", JSON.stringify(elem._id));
        }
      });
    },
    checkBoxClick(checkBoxId) {
      if (this.checkBoxSettings && this.checkBoxSettings[checkBoxId]) {
        this.checkBoxSettings[checkBoxId].checked = !this.checkBoxSettings[
          checkBoxId
        ].checked;
        this.$store.dispatch("transCheckBoxSettings", this.checkBoxSettings);
      }
    },
  },
  created() {},
  mounted() {
    if (Object.keys(this.$store.getters.transCheckBoxSettings).length < 1) {
      this.setCheckBoxes();
    }
  },
};
</script>
<style lang="scss" scoped>
$global_color: #4c709b;
$global_color_lit: #4c709bcc;

.translationChecks {
  // background-color: #ccffb3;
  background-color: $global_color;
  padding: 1px 5px 5px 5px;
  // border: 1px #99ff66 solid;
  border: 1px $global_color solid;
  // color: #003399;
  color: #eee;
  font-weight: 600;
  width: 100%;
  border-radius: 5px;

  .default {
    user-select: none;
    pointer-events: none;
    cursor: not-allowed !important;
  }

  #checkBoxDiv {
    padding-top: 5px;
    div {
      display: flex;
      // align-items: center;
      justify-content: flex-start;

      input {
        background-color: initial;
        box-sizing: border-box;
        margin: 0px 5px 0px 4px;
        padding: 0px;
        border: initial;
      }

      label {
        font-family: arial;
        font-size: 11px;
        margin-bottom: 2px;
      }
    }
    div.sep {
      border-top: 1px #cad1a5 solid;
      margin-top: 3px;
      padding-top: 5px;
    }
  }
}
</style>